/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_2_AInputs */

const en_vc_onl_faq_2_a = /** @type {(inputs: Vc_Onl_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The app runs locally in your browser. Files you open are read from your disk, and saving downloads them back to your computer.`)
};

const zh_vc_onl_faq_2_a = /** @type {(inputs: Vc_Onl_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。应用在你的浏览器里本地运行，打开的文件从你的硬盘读取，保存时会下载回你的电脑。`)
};

/**
* | output |
* | --- |
* | "No. The app runs locally in your browser. Files you open are read from your disk, and saving downloads them back to your computer." |
*
* @param {Vc_Onl_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_2_a = /** @type {((inputs?: Vc_Onl_Faq_2_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_2_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_2_a(inputs)
	return zh_vc_onl_faq_2_a(inputs)
});
export { vc_onl_faq_2_a as "vc.onl.faq.2.a" }